import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _getWidgetSettingsRequest = {};
var _getWidgetSettingsResponse = { widgetSettings: '_widgetSettings' };
var _setWidgetSettingsRequest = { widgetSettings: '_widgetSettings' };
var _setWidgetSettingsResponse = { widgetSettings: '_widgetSettings' };
var _widgetSettings = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
function resolveWixInnovationAssistantWidgetV1SettingsUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/wix-assistant-widget',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/wix-assistant-widget',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/wix-assistant-widget',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/wix-assistant-widget',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/wix-assistant-widget',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/wix-assistant-widget',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/wix-assistant-widget',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/wix-assistant-widget',
                destPath: '',
            },
            {
                srcPath: '/innovation/widget',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/wix-assistant-widget',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Retrieves the widget settings for the site. */
export function getWidgetSettings(payload) {
    var _a = serializer(_getWidgetSettingsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getWidgetSettingsResponse, {
        _widgetSettings: _widgetSettings,
    }).fromJSON;
    function __getWidgetSettings(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.innovation.widget.v1.widget_settings',
            method: 'GET',
            methodFqn: 'wix.innovation.assistant.widget.v1.Settings.GetWidgetSettings',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixInnovationAssistantWidgetV1SettingsUrl({
                protoPath: '/v1/settings',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getWidgetSettings.fromReq = fromReq;
    __getWidgetSettings.__isAmbassador = true;
    return __getWidgetSettings;
}
/** Sets the widget settings for the site. */
export function setWidgetSettings(payload) {
    var _a = serializer(_setWidgetSettingsRequest, { _widgetSettings: _widgetSettings }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_setWidgetSettingsResponse, {
        _widgetSettings: _widgetSettings,
    }).fromJSON;
    function __setWidgetSettings(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.innovation.widget.v1.widget_settings',
            method: 'POST',
            methodFqn: 'wix.innovation.assistant.widget.v1.Settings.SetWidgetSettings',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixInnovationAssistantWidgetV1SettingsUrl({
                protoPath: '/v1/settings',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __setWidgetSettings.fromReq = fromReq;
    __setWidgetSettings.__isAmbassador = true;
    return __setWidgetSettings;
}
//# sourceMappingURL=http.impl.js.map